import { io } from 'socket.io-client'
import { DOMAIN } from './api'
const socket = io(DOMAIN)

export { socket }
